<template>
  <div class="empty-logo" @click="openUrlAction('/configuracoes?page=custom')">
    <div class="empty-logo__container">
      <p class="add-logo-icon"><IconGoogle name="add_photo_alternate" size="20px" /></p>
      <p class="add-logo">{{ $t('empty_state.add_logo') }}</p>
      <p class="add-logo-text">{{ $t('empty_state.logo_recommended_size') }}</p>
      <p class="add-logo-text">{{ $t('empty_state.logo_size') }}</p>
      <p class="add-logo-text">{{ $t('empty_state.logo_title') }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";

const router = useRouter();

function openUrlAction(url: string) {
  router.push(url);
}
</script>

<style lang="scss" scoped>
.empty-logo{
    margin-top: 0;
    cursor: pointer;
    display: flex;
    width: 100%;
    max-width: 200px;
    height: 60px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1.5px dashed var(--divider-color);
    background: var(--empty-state-backgorund);
}


.add-logo-icon{
    display: flex;
    justify-content: space-around;
        :deep(.svg-inner path) {
        fill: #9E9E9E;

        [data-theme="dark"] & {
            fill: #fff;
        }
    }
}

.empty-logo__container {
    display: flex;
    align-items: center;
    gap: 8px;
}

p{
    margin: 0;
}

.add-logo{
    color: #141416;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.2;

    [data-theme="dark"] & {
    color: #fff;
    }
}

.add-logo-text{
    display: none;
}
</style>
